import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Form, Input, Button, Image, Row, Col, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { LOGIN } from '../../../../routes';
import { STATUS } from '../../../../redux/constants';
import history from '../../../../redux/history';
import Cookies from 'cookies-js';
import logo from '../../../../assets/sp_new_logo_reversed.svg';
import styles from './register.module.sass';
import { useDispatch, useSelector } from 'react-redux';
import { register, validateEmail } from '../../../../redux/actions/auth';
import { SPLinks } from '../../../../shared-components/AuthLayout';
import AuthLayout from '../../../../shared-components/AuthLayout';
import Panel from '../../../../shared-components/Panel';
import { formatEmail } from '../../../../redux/utils/email';

// function PinStepForm() {
//   const dispatch = useDispatch();

//   const handlePinSubmit = (data) => {
//     dispatch(loginWith2FA(data));
//   };

//   return (
//     <Form
//       className="login-form"
//       initialValues={{
//         remember: true,
//       }}
//       onFinish={handlePinSubmit}
//     >
//       <Form.Item
//         name="pin"
//         rules={[
//           {
//             required: true,
//             message: 'Pin Code is required',
//           },
//         ]}
//       >
//         <Input autoFocus placeholder="Pin Code" />
//       </Form.Item>

//       <Form.Item>
//         <Button type="primary" htmlType="submit" className="login-form-button">
//           Submit
//         </Button>
//       </Form.Item>
//     </Form>
//   );
// }

function RegisterForm(props) {
  const dispatch = useDispatch();
  const q = useQuery();
  const formRef = React.createRef();

  function useQuery() {
    return new URLSearchParams(useLocation()?.search);
  }

  const handleRegister = (data) => {
    dispatch(validateEmail(data?.email));
    props.setFormData(data);
  };

  const handleChange = (values) => {
    if (values?.email) {
      formRef.current.setFieldsValue({
        email: formatEmail(values.email),
      });
    }
  };

  return (
    <Form
      ref={formRef}
      initialValues={{ referral: q?.get('referral')?.replace(/\W/g, '') }}
      onFinish={handleRegister}
      onValuesChange={handleChange}
      layout={'vertical'}
    >
      <Form.Item
        label="First Name (required)"
        name="first_name"
        rules={[
          { required: true, message: 'Please enter your first name!' },
          {
            type: 'string',
            message: 'Please input a valid first name!',
          },
        ]}
      >
        <Input placeholder={'Enter your first name'} />
      </Form.Item>

      <Form.Item
        label="Last Name (required)"
        name="last_name"
        rules={[
          { required: true, message: 'Please enter your last name!' },
          {
            type: 'string',
            message: 'Please input a valid last name!',
          },
        ]}
      >
        <Input placeholder={'Enter your last name'} />
      </Form.Item>

      <Form.Item
        label="Email (required)"
        name="email"
        rules={[
          // { required: true, message: 'Please input your email!' },
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if (!value) {
                return Promise.reject('Please input your email!');
              }
              //https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression
              if (
                !value.match(
                  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
                )
              ) {
                return Promise.reject('Please input a valid email!');
              }
              //if (listOfEmailsToBlock.includes(value?.split('@')?.[1])) {
              //return Promise.reject('Please register with your work email.');
              //}
              return Promise.resolve();
            },
          }),
          // {
          //   required: true,
          //   type: 'email',
          //   message: 'Please input a valid email!',
          // },
        ]}
      >
        <Input
          //className={styles['password-input']}
          placeholder={'Enter your work email'}
        />
      </Form.Item>
      <Form.Item
        hidden
        label="Referral"
        name="referral"
        //rules={[{ required: true, message: 'Please input your email!' }]}
      >
        <Input
        //className={styles['password-input']}
        //placeholder={'Enter your email'}
        />
      </Form.Item>
      <div style={{ textAlign: 'left' }}>
        <Link className={styles['login-link']} to={LOGIN}>
          Back to Login
        </Link>
      </div>
      <p
        style={{
          margin: '8px 0 0 0',
          width: '90%',
          textAlign: 'left',
          color: 'rgba(255, 255, 255, 0.85)',
        }}
      >
        By clicking on the "Register" button you are accepting our{' '}
        <a target="_blank" href="https://www.silentpush.com/privacy-policy">
          Privacy Policy
        </a>{' '}
        and{' '}
        <a target="_blank" href="https://www.silentpush.com/terms-of-use">
          Terms of services
        </a>
      </p>
      <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
        <Button type="primary" htmlType="submit">
          Register
        </Button>
      </Form.Item>
    </Form>
  );
}

export default function Register() {
  const [showPinForm, setShowPinForm] = useState(false);
  const loggedInUser = useSelector((state) => state.user);
  const loginStatus = useSelector((state) => state.auth.loginStatus);
  const is2faEnabled = useSelector((state) => state.auth.is2faEnabled);
  const loginError = useSelector((state) => state.auth.error);
  const emailValidationErrorMessages = useSelector(
    (state) => state.auth.errorMessages,
  );
  const registerStatus = useSelector((state) => state.auth.registerStatus);
  const emailConfirmationStatus = useSelector(
    (state) => state.auth.emailConfirmationStatus,
  );

  const [formData, setFormData] = useState(null);

  const dispatch = useDispatch();
  const { Text, Title } = Typography;

  useEffect(() => {
    if (
      emailConfirmationStatus === STATUS.SUCCESS &&
      !emailValidationErrorMessages
    ) {
      dispatch(register(formData));
    }
  }, [emailConfirmationStatus]);

  useEffect(() => {
    if (loginStatus === STATUS.LOADED) {
      const tokenCookie = Cookies.get('persist:token');
      if (loggedInUser && tokenCookie) {
        const tokenFromCookie = JSON.parse(tokenCookie)['token'];
        const isTokenPresentInCookie =
          tokenFromCookie && tokenFromCookie !== '""';
        if (isTokenPresentInCookie) {
          history.push('/');
          return () => {};
        }
      }
      if (is2faEnabled) {
        setShowPinForm(true);
      }
    }
  }, [loggedInUser, loginStatus, is2faEnabled]);

  function RegisterEmailSent() {
    return (
      <AuthLayout
        title={'Confirmation email has been sent'}
        description={
          <>
            To proceed with creating your account you need to verify your email
            address from the email we've sent you.
          </>
        }
      />
    );
  }

  return emailConfirmationStatus === STATUS.SUCCESS &&
    !emailValidationErrorMessages ? (
    <RegisterEmailSent />
  ) : (
    <Row className={styles.login} gutter={24} align="middle" justify="center">
      <Col xs={24} md={13} lg={10} xl={9} xxl={7}>
        <Panel bgcolor={'#1C3138'} className={styles.loginPanel}>
          <>
            <div>
              <img alt={'silentpush logo'} src={logo} width={277} />
            </div>
            <Title level={2}>Register a trial account</Title>
            <div style={{ marginBottom: 16 }}>
              {emailValidationErrorMessages &&
                !emailValidationErrorMessages?.[0]?.includes(
                  'support@silentpush[.]com',
                ) && (
                  <span className={styles['login-error']}>
                    Due to the sensitive content of our application, please
                    register with your work email.
                  </span>
                )}
              {emailValidationErrorMessages &&
                emailValidationErrorMessages?.[0]?.includes(
                  'support@silentpush[.]com',
                ) && (
                  <span className={styles['login-error']}>
                    Please contact our support team at support@silentpush.com
                  </span>
                )}
            </div>
            <RegisterForm setFormData={setFormData} />
          </>
        </Panel>
        <SPLinks />
      </Col>
    </Row>
  );
}
